// extracted by mini-css-extract-plugin
export default {"notification":"SimphonyPOS_notification__dV2c1"};